/**
 * LegacyDoctorSlugRedirect (iter100.260) — client redirect from
 * legacy `/s/…` doctor URLs to canonical `/dr/…` routes. We do NOT
 * strip the `dr-` prefix here — the backend's public-doctor endpoint
 * already stores previous slugs in `previous_slugs[]` and returns a
 * `canonical_slug` in its response, so DoctorLandingPage does the
 * final canonical redirect itself. Our job is only to move the visitor
 * from the deprecated `/s/…` namespace onto the new `/dr/…` namespace.
 *
 *   /s/dr-james-wilson     → /dr/dr-james-wilson
 *     (DoctorLandingPage then redirects to /dr/james-wilson-old, the
 *     doctor's current canonical slug, via canonical_slug in the API
 *     response.)
 *   /s/dr-x/article/foo    → /dr/dr-x/article/foo
 *   /s/dr-x/case/bar       → /dr/dr-x/case/bar
 */
import React from "react";
import { Navigate, useParams, useLocation } from "react-router-dom";

export default function LegacyDoctorSlugRedirect({ kind }) {
    const params = useParams();
    const { hash } = useLocation();

    let target = "";
    if (kind === "landing") {
        target = `/dr/${params.slug}`;
    } else if (kind === "article") {
        target = `/dr/${params.doctorSlug}/article/${params.articleSlug}`;
    } else if (kind === "case") {
        target = `/dr/${params.doctorSlug}/case/${params.caseSlug}`;
    } else {
        target = "/";
    }
    return <Navigate to={`${target}${hash || ""}`} replace />;
}
